// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__fuD93","author":"Table_author__KUkAC","authorImage":"Table_authorImage__3PQ2Z","unreadRow":"Table_unreadRow__jxbx5"};